module.exports = __webpack_public_path__ + "img/low.f9515ab3.svg";